// extracted by mini-css-extract-plugin
export default {"body":"RanIntoProblem_body__rfDYw","text":"RanIntoProblem_text__PMn34","wind":"RanIntoProblem_wind__S1HLg","emoticon":"RanIntoProblem_emoticon__cgHgl"};